import { QueryClient } from "@tanstack/react-query";
import { shouldRetryQuery } from "utils/queryRetry";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Data is immediately stale
      cacheTime: 1000 * 60 * 5, // Keep in cache for 5 minutes but mark as stale immediately
      refetchOnWindowFocus: true, // Refetch on window focus to get fresh data
      refetchOnMount: true, // Always refetch on component mount
      retry: shouldRetryQuery, // Do not retry 4xx (e.g. 403 missing scope)
    },
  },
});

export default queryClient;
